import type { MarketplaceIncentive } from '@carvana/merch-contracts';

export default function resolveIncentives(
  incentiveIds: string[],
  marketplaceIncentives: MarketplaceIncentive[]
): MarketplaceIncentive[] {
  const idSet = new Set(incentiveIds);

  return marketplaceIncentives.filter(incentive =>
    idSet.has(incentive.programId)
  );
}
